function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/dataprocessor/htmldataprocessor
 */

/* globals document, DOMParser */
import BasicHtmlWriter from './basichtmlwriter';
import DomConverter from '../view/domconverter';
/**
 * The HTML data processor class.
 * This data processor implementation uses HTML as input and output data.
 *
 * @implements module:engine/dataprocessor/dataprocessor~DataProcessor
 */

var HtmlDataProcessor =
/*#__PURE__*/
function () {
  /**
   * Creates a new instance of the HTML data processor class.
   *
   * @param {module:engine/view/document~Document} document The view document instance.
   */
  function HtmlDataProcessor(document) {
    _classCallCheck(this, HtmlDataProcessor);

    /**
     * A DOM parser instance used to parse an HTML string to an HTML document.
     *
     * @private
     * @member {DOMParser}
     */
    this._domParser = new DOMParser();
    /**
     * A DOM converter used to convert DOM elements to view elements.
     *
     * @private
     * @member {module:engine/view/domconverter~DomConverter}
     */

    this._domConverter = new DomConverter(document, {
      blockFillerMode: 'nbsp'
    });
    /**
     * A basic HTML writer instance used to convert DOM elements to an HTML string.
     *
     * @private
     * @member {module:engine/dataprocessor/basichtmlwriter~BasicHtmlWriter}
     */

    this._htmlWriter = new BasicHtmlWriter();
  }
  /**
   * Converts a provided {@link module:engine/view/documentfragment~DocumentFragment document fragment}
   * to data format &mdash; in this case to an HTML string.
   *
   * @param {module:engine/view/documentfragment~DocumentFragment} viewFragment
   * @returns {String} HTML string.
   */


  _createClass(HtmlDataProcessor, [{
    key: "toData",
    value: function toData(viewFragment) {
      // Convert view DocumentFragment to DOM DocumentFragment.
      var domFragment = this._domConverter.viewToDom(viewFragment, document); // Convert DOM DocumentFragment to HTML output.


      return this._htmlWriter.getHtml(domFragment);
    }
    /**
     * Converts the provided HTML string to a view tree.
     *
     * @param {String} data An HTML string.
     * @returns {module:engine/view/node~Node|module:engine/view/documentfragment~DocumentFragment|null} A converted view element.
     */

  }, {
    key: "toView",
    value: function toView(data) {
      // Convert input HTML data to DOM DocumentFragment.
      var domFragment = this._toDom(data); // Convert DOM DocumentFragment to view DocumentFragment.


      return this._domConverter.domToView(domFragment);
    }
    /**
     * Converts an HTML string to its DOM representation. Returns a document fragment containing nodes parsed from
     * the provided data.
     *
     * @private
     * @param {String} data
     * @returns {DocumentFragment}
     */

  }, {
    key: "_toDom",
    value: function _toDom(data) {
      var document = this._domParser.parseFromString(data, 'text/html');

      var fragment = document.createDocumentFragment();
      var nodes = document.body.childNodes;

      while (nodes.length > 0) {
        fragment.appendChild(nodes[0]);
      }

      return fragment;
    }
  }]);

  return HtmlDataProcessor;
}();

export { HtmlDataProcessor as default };